(function () {
    'use strict';

    angular
        .module('invesfleet')
        .filter('capitalize', capitalizeFilter);

    function capitalizeFilter() {
        return function(text){
            if(text && typeof text === 'string' || text instanceof String){
                var lowercaseText = text.toLowerCase();
                return lowercaseText.substr(0,1).toUpperCase()+ lowercaseText.substr(1,lowercaseText.length-1);

            }
            return text;
        };
    }

})();